var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40625 7.53125L2.34375 13.625C2.03125 13.9062 1.5625 13.9062 1.28125 13.625L0.5625 12.9062C0.28125 12.625 0.28125 12.1562 0.5625 11.8438L5.375 7L0.5625 2.1875C0.28125 1.875 0.28125 1.40625 0.5625 1.125L1.28125 0.40625C1.5625 0.125 2.03125 0.125 2.34375 0.40625L8.40625 6.5C8.6875 6.78125 8.6875 7.25 8.40625 7.53125Z",
    fill: "#002C3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight1);
export default __webpack_public_path__ + "static/media/chevron-right (1).210624290ea0830917b75b68305e5f5e.svg";
export { ForwardRef as ReactComponent };